import React from 'react';

const Tree = () => <svg
  version="1.1"
  id="EcoTree"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 648 132"
  contentStyleType="enable-background:new 0 0 648 132"
  xmlSpace="preserve"
>
  <g id="grup_1">
    <path className="st0" d="M1.3,130.2h120.1c0,0,11,0,20.8-7.3c9.8-7.3,25.7-8.2,25.7-8.2s-1.8-42.7,5-59.2c0,0,2.8-12.6-7.6-13.7 c0,0,4,4.1,2.1,9.8s-13.3,7.5-19.1,6.1s-14.1-6.8-20.7-1.9c0,0-0.3-26.1,21.1-30.8c0,0,13-2.9,16.1,12.6c0,0-16.8-3.9-26.4,7.4 c0,0,9.2-7,20.9-6.4s16.1,6.1,17.3,8c0,0,5.5-14.6,8.9-17.7s1.8-4.9,0-6.9s-1.6-4.5,1.3-9.4s0.3-10.8,0.3-10.8s13.2,8.6,2.9,25.6 c0,0,3.4-4.4,10.7-4.2s12.2-1.7,13.6-4.1s2.3-4,2.3-4s-0.6,14.2-9.2,17.5s-14.5-0.4-17.1-1.2s-5.1,1.6-9.4,11.9 c0,0,9.2-1.6,17.8,0.4c0,0,1.1-4.8,8.8-3.8s13.9,8.8,15.5,16.5s-0.7,19.4-0.5,19.3s-0.5-7.9-11.9-8.7s-19.6-6.1-20.1-11.4 s2.2-9.9,6.8-9.8s14.8,5.9,18.9,12.9s-9.5-16.5-19.9-16.9s-18.1,3.5-21.4,14.9s-3.4,52.5-2.9,57.9c0,0,14,1,29.6,8.5s14,6.9,28.9,7 s416.6,0,416.6,0" />
  </g>
  <g className="point-start">
    <circle fill="none" cx="647" cy="130" r="1.4" />
  </g>
</svg>

const Whale = () => <svg
  version="1.1"
  id="EcoWhale"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 216 85"
  contentStyleType="enable-background:new 0 0 216 85"
  xmlSpace="preserve"
>
  <g id="grup_1">
    <path className="st0" d="M146.8,47.2c0,0-7.4,7.5-20.5,7.6s-19.4-3-25.3,4.8s-0.3,20.6,17.3,20c0,0,7.3-10.4-18.4-21.9 S63.8,43.8,59.4,40.8s-7.4-5.5-6.3-9.2s9-3.4,10-1c1,2.4-5.3,5.6-11.9,0.5s-4.9-12.1-13.6-15.4S10.3,6.2,4.3,10.2 s-1.8,13.9,8.6,20.6s10.4,14.6,21.4,22.6s35.5,26,87.1,13.5c0,0,28.7-8.3,54.1-34.1c0,0,2.4-2.5,7.6,1.9c0,0,9.4,10.4,27.9,3.1 c0,0-2.6-16.2-17.1-14.9s-7,7.5-1.9,5.6s16-11.7,11.5-19.7c0,0-7.9,0.7-18.1,8.8S160.8,37.8,147,37.8s-14.9-5.5-22.2-5.4 c-7.4,0.1-22.5,0.3-32.5-3.6S71.4,14.3,60.8,10.3S38.4,7.2,33.3,6.6s-13-4.6-23.8-2.4c-9.3,2-6.1,3.9-5.2,6" />
  </g>
  <g className="point-end">
    <circle fill="none" cx="214.3" cy="2.2" r="1.4" />
  </g>
</svg>

const Guy = () => <svg
  version="1.1"
  id="EcoGuy"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 973 244"
  contentStyleType="enable-background:new 0 0 973 244"
  xmlSpace="preserve"
>
  <g id="grup_1">
    <path className="st0" d="M397.1,198.4c-7.7-1.5-10.8-14.2-7.1-24s13.3-22.3,7.2-33.8c-6.2-11.5-3-25.5,1.5-15.3s-4,12.7-4,12.7 c-16.8,5.9-5.9,26.9-4.1,33.1s8.3,25.2,7,39.1s-16.9,14.2-16.9,14.2s2.6-7.3-0.3-16.9c-2.8-9.6-7.5-7.3-9.1-5.5s3.7,9.8,5.4,15.5 s-0.5,16.5-2.5,21.8c-2,5.3-9.3,5.4-13.3,0.5c-4.1-4.9-3-13.3,0.9-20.2c3.9-6.8,9.5-2.2,9.5-2.2s-6.8,1.3-9.3-1.7 c-2.5-2.9-0.4-7.3,2.8-10.2c3.3-2.8,8.4-1.5,13.7-4.4s0.3-17.3-5.5-27.9c-5.8-10.6-8.9-12.3-15.9-8.5s-14.2,15.3-25.1,21.4 c-10.9,6.1-14.2,1.9-12.8-0.5c1.3-2.4,5.8-1.2,7.6,2.8s12.8,7.8,13.3,9.8c0.5,2.1-3.4,10.3-3.4,10.3s-24.7-6.8-28.2-15.8 s9.8-27.1,18.1-34.6s15.1-17.6,15.1-17.6c2.4,0.9,11.6,4,20.8,5.4c9.3,1.4,18.8-2.8,18.8-2.8c7.2,6.3,1,13.2,1,13.2 c-4.4,6.8-17.3,11.2-28.4,13.3s-23.9,8.6-26,13.3s9.3,8.8,12.7,10.6c3.3,1.8,7,2.3,4.6,7.6s-1.3,13.6-1.3,13.6s0.4-0.7,1-7.5 c0.6-6.8,4.8-8.7,8.1-9.3c3.3-0.7,5.6,4.2,5.3,7.4s-5.7,4.9-5.7,4.9s2,10.6,0,17.8s-9.5,8.2-11.2,6.6c-1.7-1.6,0.5-5.8,1.2-9.8 c0.7-4.1-2.4-10.8-2.4-10.8h-37.5c0,0-70.4,2.3-96.6-2.3s-25.4-20.3-24.8-26.5s6.5-24,27.7-23s22.4,17,22.4,17s12.3-7.4,25.5-1.7 s11.9,22.8,11.9,22.8s16.8-6,18.5,7.6c2.1,17.5-14.7,18.5-14.7,18.5h-274" />
    <path className="st0" d="M444.9,28.9c0,0-15.2,12.5-22.2,20.7s-13,16-18.8,20c-5.8,4-10.3,7.3-13,23.2c-2.7,15.8,4.7,30.8,5.7,35 c1,4.2-7.3,1.7-11-13.7s-0.2-33,9.2-41.7c0,0-12,3-17.5,19.7s6.8,33,11,36.7c0,0-11.2,14.7-25.7,10.7s-12-7-27.2-7.2 c-15.2-0.2-33.5,0.8-31.8-21.3c0,0,21.7-1.7,25.3-12.5c3.7-10.8,2.2-22.8-2.3-28.5c-4.5-5.7-10.2-5.2-9.5-12.7s-5.7-14.8-9.2-20.2 s-9.3-10.8-5.3-14s7-11.6-2.1-21.7c0,0,1.1,8.4-1.7,11.3s-5.3,3.1-8.8,3.3c-3.4,0.3-6,1.4-2.5,2.8c3.5,1.3,9.8,0.8,12.3,2 c2.4,1.2,3.8,3.3,10.3,1.9s8.4,0.3,11.4,5.7s0.9,8.6,5.2,11.6s5.2,4.5,5.6,7.4c0.4,2.9,4.8,6,7.8,7.8s7.7,5.6,17.2,7 s15.4,0.3,14.1-4.8s-1.5-9.3-1-9.5s4.4,1,4.8-3.7s-2.3-5.8-3-5.4c-0.8,0.4-1.4-4.4-1.3-5.8c0.1-1.4,2.3-2.6,2.8-6s0.1-3.9,0.1-3.9 s-0.5,2.1-3.3,3.1c-2.8,1-4.2,0.7-4.2,0.7s2.8-1.3,2.8-3.6c0,0-2.3,1.5-4.8,1.3c-2.4-0.2-15.1-1.7-17.3,4s-0.3,14.5-0.3,14.5 s-3.6-2.4-3.6,1.1s-0.7,5.3,4.2,7.1c0,0-0.4,6.9,3.4,10.6s9.2-4.7,16.4-4.2s9.6-0.9,13.2-0.8c3.6,0.1,5.6,2.7,10.3,2.6 c4.8-0.1,12.5-13.9,19.8-17.3c7.3-3.4,10.3-5.5,14.6-12.6s8.5-13.9,13.3-11.4s7.7,8.1,12.8,6.6C456,23.2,461,19,461,19 s-0.3-1.4-4.1-1.4c-3.8,0-9-1.6-9.7-3.2s2.6-7.7,2.5-9.4s-0.8-2.6-1.5-1.8s-3.6,5.5-5.3,8.8s-6.1,3.8-4,8.9 C441,25.9,444.9,28.9,444.9,28.9z" />
    <path className="st0" d="M971.3,173.9h-141l59.3-35l-0.5-11.5l-80.5,45.3l-75.8,1.3l79.3-46.5l80-16l-85.3,50.3l-81.5,16.7 c0,0-31.1-22.3-63.8-10.5v-6.2c0,0,36.5-9.1,64,13.1c0,0-24.2-28.5-64-22.3l14.5-9c0,0,37.5,4.3,50.5,28.7l84-47.8 c0,0-11.2-33.2-46.7-32l-83.5,48.5c0,0-9.2-0.7-14.7,0.2l94.5-53.7c0,0,40.4-3.5,53.5,35.8l84.3,0.2v7l-88.5,51.2H721 c0,0-14.3-17.8-59.5-8H549c0,0,12.2-17-7.8-26.7c-20-9.7-30.3,5.7-26.3,13.8c0,0-12.3-10.5-25-6c-12.7,4.5-14.7,15.2-7.8,26.8h91.5 c0,0,13.7-4.3,13-18.7c-0.7-14.3-15.5-21.5-29.5-16.7c0,0,0.3-20.3-17.5-22.8c-17.8-2.5-27.3,5.7-27.3,5.7s-7-18-31.8-14.7 c-24.8,3.3-31.3,29.2-26.7,50.5c0,0-12.7-3.3-15.7,7.5c-3,10.8,1.5,15.8,11.5,24.3l-51.9,1.8" />
  </g>
</svg>

const Switch = () => <svg
  version="1.1"
  id="IntroSwitch"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 375 384"
  contentStyleType="enable-background:new 0 0 375 384"
  xmlSpace="preserve"
>
  <g id="grup_1">
    <path className="st0" d="M6.2,4.5H354c7,0,12.8,5.7,12.8,12.8v307.5c0,7-5.7,12.8-12.8,12.8H19c-7,0-12.8-5.7-12.8-12.8V22.2 c0-7,5.7-12.8,12.8-12.8h325c7,0,12.8,5.7,12.8,12.8V310c0,7.5-6,13.5-13.5,13.5H99.5c-5.7,0-10.3-4.6-10.3-10.3V84 c0-5.5,4.5-10,10-10H270c5.1,0,9.3,4.1,9.3,9.3V251c0,5.8-4.7,10.5-10.5,10.5H104.5c-5.7,0-10.3-4.6-10.3-10.2V88c0-5,4-9,9-9h73.4 c4.9,0,8.9,4,8.9,8.9l2,157.8c0,5.5-4.4,9.9-9.9,9.9h-72.9" />
  </g>
</svg>


const Economisesc = {
  Tree,
  Whale,
  Guy,
  Switch
};

export default Economisesc;


// WEBPACK FOOTER //
// ./src/components/svg/Economisesc.jsx